import React from 'react';
import { PersonProfileImageSmall } from '../../../../../PersonProfileImageSmall';
import { TextMarker } from '../../../../../../../_lib/components/TextMarker/TextMarker';
import { TopUserResult } from '../types/SuggestResultTypes';

type ListItemPersonType = {
  user: TopUserResult;
  withEmail?: boolean;
  withPhone?: boolean;
};

/**
 * Renders a single person item for a List in <a href='#formscombobox'>FormsCombobox</a>.
 */
function ListItemPerson({ user, withEmail = false, withPhone = false }: ListItemPersonType) {
  // we need an empty alt-attribute here
  // because it's redundant info for screen reader users
  // otherwise the user name would be read twice
  const profileImageUrl = {
    src: user.profileImageUrl.src,
    name: '',
    availableWidths: user.profileImageUrl.availableWidths,
  };

  return (
    <span className="combobox__list-item-padding combobox__list-item-padding--person">
      <PersonProfileImageSmall
        profileName="" // we need no alt here because it would double with the visible name
        emptyAltText
        profileImageUrl={profileImageUrl as any}
      />
      <span className="combobox__list-text">
        <span className="combobox__list-name">
          <TextMarker text={user.profileNameWithoutHighlighting} type="strong" />
        </span>
        {withEmail && (
          <span className="combobox__list-email">
            <TextMarker text={(user.emailLink || {}).name || ''} type="strong" />
          </span>
        )}
        {user.phoneLink && (
          <span className="combobox__list-phone">
            <TextMarker text={(user.phoneLink || {}).name || ''} type="strong" />
          </span>
        )}
        {withPhone && (
          <span className="combobox__list-phone">
            <TextMarker text={user.telephone} type="strong" />
          </span>
        )}
      </span>
    </span>
  );
}

// We dont update this component in lists.
// Currently used in combobox, where it will always have the newest props as it is fetched.
export default React.memo(ListItemPerson);
